<template>
  <v-radio-group
    v-model="selectedWritingQuestion"
    hide-details
    row>
    <v-radio
      v-for="(option, index) in options"
      :key="index"
      :label="option.text"
      :value="option.value"
      color="secondary"
    ></v-radio>
  </v-radio-group>
</template>

<script>
import teacher from '../../mixins/teacher';

export default {
  mixins: [teacher],

  data: () => ({
    options: [
      {text: '出題する', value: true},
      {text: '出題しない', value: false},
    ],
  }),

  computed: {
    selectedWritingQuestion: {
      get() {
        return this.currentSubjectCondition.selectedWritingQuestion;
      },
      set(value) {
        this.$store.commit('changeCurrentSubjectCondition', { selectedWritingQuestion: value })
      }
    },
  }
}
</script>
